import { useState } from "react";

export type AddNotePayload = { note: string };

type AddNotePanelProps = {
  initialNote?: string;
  onSubmit: (payload: AddNotePayload) => void;
  onCancel: () => void;
  submitting?: boolean;
};

export function AddNotePanel({ initialNote = "", onSubmit, onCancel, submitting }: AddNotePanelProps) {
  const [note, setNote] = useState(initialNote);

  return (
    <form
      className="space-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit({ note: note.trim() });
      }}
    >
      <div>
        <label htmlFor="activity-note" className="block text-sm font-medium text-text">
          Note
        </label>
        <textarea
          id="activity-note"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={4}
          className="mt-1 w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
          placeholder="Saisissez votre note…"
        />
      </div>
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="rounded-md border border-border bg-surface px-3 py-1.5 text-sm text-text hover:bg-surface-muted"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={submitting || !note.trim()}
          className="rounded-md bg-accent px-3 py-1.5 text-sm font-medium text-white hover:bg-accent-hover disabled:opacity-50"
        >
          {submitting ? "Envoi…" : "Enregistrer"}
        </button>
      </div>
    </form>
  );
}
